import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "app/App";
import { store } from "app/store";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import CookieBanner from "features/cookie-banner/CookieBanner";

function onAcceptStatistics() {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID || "",
  };
  TagManager.initialize(tagManagerArgs);
}

const cookiePolicyLink = process.env.REACT_APP_POLICY_LINK;

axios.defaults.withCredentials = true;
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
    <CookieBanner
      onAcceptStatistics={onAcceptStatistics}
      policyLink={cookiePolicyLink}
    />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
